var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"control-sidebar control-sidebar-dark"})
}
var staticRenderFns = []

export { render, staticRenderFns }